import React, { Component } from "react";
import { connect } from "react-redux";
import { DIMENSIONS } from "services/layoutManager";
import { TICKET_TYPES } from "utils/TicketConstants";
import BloxPage from "sub_components/Layout/BloxPage";
import ComponentWrapper from "sub_components/Layout/ComponentWrapper";
import DonutChart from "sub_components/Common/DonutChart";
import RecentPayment from "blox_components/Billing/RecentPayment";
import RecentInvoices from "blox_components/Billing/RecentInvoices";
import TotalAmountDue from "blox_components/Billing/TotalAmountDue/TotalAmountDue";
import {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
} from "actions/siteTracking";
import { SITE_PAGES, SITE_MODULES } from "utils/CommonConstants";
import { MENU as BILLING_MENU } from "utils/BillingConstants";
import { BillingApi } from "services/billing";
import { BillingUtils } from "services/billing";
import { RESOLUTIONS } from "services/config";
import { Permissions } from "services/permissions";
import { Utils } from "services/utils";
import { updatePermissions } from "actions/permissions";
import { SERVICE_IDS } from "services/utils";
import { setHomeTour } from "actions/tour";
import { BloxButton } from "styled_components/Common/BloxButton";
import { JoyRideToolTip } from "styled_components/Common/JoyRideToolTip";
import { getUserPermissions, setUserPermissions } from "services/user";
import Joyride from "react-joyride-react-19";
import { TicketApi } from "services/ticket";

const LAYOUT_CONFIG = {
  [RESOLUTIONS.LOW]: {
    recentInvoices: { x: 1, y: 25, dim: DIMENSIONS.TWO_BY_SIX },
    totalAmountDue: { x: 1, y: 2, dim: DIMENSIONS.TWO_BY_SIX },
    recentPayment: { x: 8, y: 25, dim: DIMENSIONS.TWO_BY_THREE },
    ticketDonut: { x: 9, y: 2, dim: DIMENSIONS.TWO_BY_TWO },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.MED]: {
    recentInvoices: { x: 1, y: 31, dim: DIMENSIONS.TWO_BY_SIX },
    totalAmountDue: { x: 1, y: 0, dim: DIMENSIONS.TWO_BY_SIX },
    recentPayment: { x: 8, y: 31, dim: DIMENSIONS.TWO_BY_THREE },
    ticketDonut: { x: 9, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.HIGH]: {
    recentInvoices: { x: 1, y: 51, dim: DIMENSIONS.TWO_BY_SIX },
    totalAmountDue: { x: 1, y: 3, dim: DIMENSIONS.TWO_BY_SIX },
    recentPayment: { x: 8, y: 51, dim: DIMENSIONS.TWO_BY_THREE },
    ticketDonut: { x: 9, y: 3, dim: DIMENSIONS.TWO_BY_TWO },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
};

class OverviewPage extends Component {
  constructor() {
    super();
    this.state = {
      showTitleTicketCount: true,
      showTitleRecentInvoices: true,
      showTitleRecentPayment: true,
      pages: null,
      runTour: false,
      bonitaTicketType: null,
      loading: true,
    };
  }

  componentWillUnmount() {
    Utils.removeHorizontalBar();
  }

  componentDidMount() {
    const {
      updateModule,
      updatePage,
      addPageToBreadCrumbs,
      site,
      permissions,
      location,
      setHomeTour,
      company_info: { customer: { id } } = {},
    } = this.props;
    updatePage(SITE_PAGES.BILLING[BILLING_MENU.OVERVIEW]);
    addPageToBreadCrumbs(
      SITE_PAGES.BILLING[BILLING_MENU.OVERVIEW],
      SITE_MODULES.BILLING
    );
    if (site?.module !== "BILLING" || !permissions?.permissions) {
      this.getModulePages();
    }
    const search = location?.search;

    if (id) {
      this.getInvoices(id);
    }

    if (search.includes("tour=true")) {
      setHomeTour({ runHomeTour: true, action: "start" });
      this.setState({ runTour: true });
    }
    updateModule(SITE_MODULES.BILLING);

    Utils.showHorizontalBar();
    this.getTicketType("billing");
  }

  setInvoiceResponse = (response, invoices) => {
    if (Utils.isValidResponse(response) && invoices && invoices.length !== 0) {
      this.setState({ invoices, loading: false });
    } else {
      this.showTitleRecentPayment(false);
      this.setState({
        showRecentPayment: false,
        error: "Error pulling recent invoices",
        loading: false,
      });
    }
  };

  setIntactInvoiceResponse = (invoices) => {
    const formattedInvoices = BillingUtils.formatIntacctInvoice(invoices);
    this.setState({ invoices: formattedInvoices, loading: false });
  };

  getInvoices = async () => {
    const { company_info: { customer: { id, customerId = 0 } } = {} } =
      this.props;
    const response = await new BillingApi().getAll(id, null, customerId);
    const { data: { invoices = [], intacctInvoices = [] } = {} } = response;

    if (intacctInvoices && intacctInvoices.length !== 0) {
      this.setIntactInvoiceResponse(intacctInvoices);
    } else {
      this.setInvoiceResponse(response, invoices);
    }
  };

  hasNextModule = () => {
    const { location } = this.props;
    const moduleOrder = location?.state?.moduleOrder;

    if (moduleOrder && moduleOrder.length !== 0) {
      const currentIndex = moduleOrder.indexOf(4);
      const nextIndex = moduleOrder[currentIndex + 1];

      if (!nextIndex) {
        return false;
      } else {
        return true;
      }
    }
  };
  componentDidUpdate(prevProps) {
    const {
      location,
      setHomeTour,
      company_info: { customer: { id } } = {},
    } = this.props;

    const search = location?.search;
    const prevSearch = prevProps?.location?.search;

    if (search !== prevSearch && search.includes("tour=true")) {
      this.setState({ runTour: true });
      setHomeTour({ runHomeTour: true, action: "start" });
    }

    const previousCompanyId = prevProps?.company_info?.customer?.id;

    if (previousCompanyId !== id) {
      this.getInvoices(id);
    }
  }
  goToNextModule = () => {
    const { location, navigate } = this.props;
    const moduleOrder = location?.state?.moduleOrder;

    if (moduleOrder && moduleOrder.length !== 0) {
      const currentIndex = moduleOrder.indexOf(4);
      const nextIndex = moduleOrder[currentIndex + 1];

      if (nextIndex) {
        const nextModule = SERVICE_IDS[nextIndex];
        const url = `/portal`;
        navigate(url, { state: { nextModule, moduleOrder } });
      }
    }
  };

  getModulePages = async () => {
    const {
      updatePermissions,
      auth_status: {
        user: { id: userId },
      },
      company_info: {
        customer: { id: orgId },
      },
    } = this.props;
    //check cache
    const permissions = getUserPermissions("billing");
    if (!permissions) {
      const response = await Permissions.getModulePermissions(4, userId, orgId);
      if (response && !response.data.error) {
        setUserPermissions("billing", response.data.pages);
        updatePermissions(response.data.pages);
      }
    } else {
      updatePermissions(permissions);
    }
  };

  showTitleTicketCount = (show) => {
    const { showTitleTicketCount } = this.state;

    if (showTitleTicketCount !== show) {
      this.setState({ showTitleTicketCount: show });
    }
  };

  showTitleRecentInvoices = (show) => {
    const { showTitleRecentInvoices } = this.state;
    if (showTitleRecentInvoices !== show) {
      this.setState({ showTitleRecentInvoices: show });
    }
  };
  showTitleRecentPayment = (show) => {
    const { showTitleRecentPayment } = this.state;
    if (showTitleRecentPayment !== show) {
      this.setState({ showTitleRecentPayment: show });
    }
  };
  closeTour = (joyride) => {
    const { setHomeTour, navigate } = this.props;
    const action = joyride?.action;
    if (action === "close" || action === "reset" || action === "stop") {
      setHomeTour({ runHomeTour: false, action });
      this.setState({ runTour: false });
      navigate("/portal/billing");
    }
  };

  getTicketType = (type) => {
    TicketApi.getTicketType(type)
      .then((response) => {
        if (response.status === 200 && response?.data && !response.data.error) {
          this.setState({ bonitaTicketType: response?.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  goToTicketHistory = (status, type) => {
    const { navigate } = this.props;
    navigate("/portal/support/ticket_history", { state: { status, type } });
  };

  render() {
    const {
      breakpoint,
      location,
      navigate,
      site,
      permissions: pages,
      company_info: { customer: { id, customerId = 0 } = {} } = {},
    } = this.props;
    const {
      showTitleTicketCount,
      showTitleRecentInvoices,
      showTitleRecentPayment,
      runTour,
      bonitaTicketType,
      loading,
      invoices,
    } = this.state;
    const ViewAmountDue = Permissions.checkComponentAccess(
      pages,
      "Overview",
      "view-amount-due"
    );
    const ViewRecentInvoices = Permissions.checkComponentAccess(
      pages,
      "Overview",
      "view-recent-invoices"
    );
    const ViewRecentPayments = Permissions.checkComponentAccess(
      pages,
      "Overview",
      "view-recent-payments"
    );
    const ViewTicketStatus = Permissions.checkComponentAccess(
      pages,
      "Overview",
      "view-ticket-status"
    );
    const steps = [
      {
        title: "Billing Overview",
        content:
          "This is the Billing module, which contains all your invoices and provides the ability to view account balance, recent payments, and invoices and download invoices.",
        placement: "center",
        locale: { skip: "S-K-I-P" },
        target: ".header-section",
        module: "billing",
      },
      {
        target: ".total-amount-due",
        content: "Here at the top, you will find your current account balance.",
        module: "billing",
      },
      {
        target: ".recent-payment-wrapper",
        content:
          "Recent payments are displayed in this area. Payments may take up to 24 hours to be reflected in this site.",
        module: "billing",
      },
      {
        target: ".recent-invoices-wrapper",
        content:
          "In this area, I like to show up to three most recent invoices and their status. The invoices change colors based on the status. My favorite color is blue, by the way.",
        module: "billing",
      },
      {
        content: this.hasNextModule()
          ? `You are a cloud storage customer, and we have a module specifically for managing your cloud storage environment.`
          : "Our tour is complete.",
        customNextButton: this.hasNextModule() ? (
          <BloxButton
            className="buttons41"
            id="continue-tour"
            text="Next"
            module="billing"
            enabled={true}
            onClick={this.goToNextModule}
            cypressId="continue-tour"
          />
        ) : null,
        target: ".header-section",
        locale: { next: "Finish" },
        placement: "center",
        module: "billing",
      },
    ];

    return (
      <BloxPage
        name="page billing-overview-page"
        layout={LAYOUT_CONFIG[breakpoint]}
        breakpoint={breakpoint}
        location={location}
      >
        <div key={`tourButton`} className="tourButton">
          {pages && (
            <Joyride
              steps={steps}
              continuous={true}
              showProgress
              showSkipButton
              styles={{
                options: {
                  zIndex: 5000,
                },
              }}
              tooltipComponent={JoyRideToolTip}
              run={runTour}
              callback={this.closeTour}
              disableScrolling={true}
              disableOverlayClose={true}
            />
          )}
        </div>
        <div key={`ticketDonut`} className="ticketDonut">
          {ViewTicketStatus && showTitleTicketCount && (
            <ComponentWrapper
              title={showTitleTicketCount ? "Billing Tickets" : ""}
              site={site}
              breakpoint={breakpoint}
              hideBorder
              titleClass="center"
            >
              <DonutChart
                ticketType={TICKET_TYPES.BILLING}
                showTitle={this.showTitleTicketCount}
                goToTicketHistory={this.goToTicketHistory}
                ticketTypePermission={bonitaTicketType}
                id="billing"
                breakpoint={breakpoint}
                navigate={navigate}
                pages={pages}
              />
            </ComponentWrapper>
          )}
        </div>
        <div key={`recentInvoices`} className="recentInvoices">
          {ViewRecentInvoices && (
            <ComponentWrapper
              title={showTitleRecentInvoices ? "Recent Invoices" : ""}
              hideBorder
            >
              <RecentInvoices
                breakpoint={breakpoint}
                showTitle={this.showTitleRecentInvoices}
                navigate={navigate}
                loading={loading}
                invoices={invoices}
              />
            </ComponentWrapper>
          )}
        </div>
        <div key={`recentPayment`} className="recentPayment">
          {ViewRecentPayments && (
            <ComponentWrapper
              title={showTitleRecentPayment ? "Recent Payment" : ""}
              hideBorder
            >
              <RecentPayment
                breakpoint={breakpoint}
                showTitle={this.showTitleRecentPayment}
                orgId={id}
                navigate={navigate}
                intacctId={customerId}
              />
            </ComponentWrapper>
          )}
        </div>

        <div key={`totalAmountDue`} className="totalAmountDue">
          {ViewAmountDue && (
            <ComponentWrapper title="Total Amount Due" hideBorder>
              <TotalAmountDue
                navigate={navigate}
                pages={pages}
                invoicesLoaded={loading}
                invoices={invoices}
              />
            </ComponentWrapper>
          )}
        </div>
      </BloxPage>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth_status: state.auth_status,
    company_info: state.company_info,
    site: state.site_tracking,
    permissions: state.permissions,
  };
}

export default connect(mapStateToProps, {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
  updatePermissions,
  setHomeTour,
})(OverviewPage);
